export default {
  ApiBaseUrl: process.env.REACT_APP_API_BASE_URL ?? '',
  FrontendBaseUlr: process.env.REACT_APP_FRONTEND_BASE_URL ?? ''
};
